export default __webpack_public_path__ + "static/media/shopping-bag.16571229.svg";